import { Tour } from "antd";
import React from "react";
import BubbleButton from "ui/BubbleButton";

import type { OnboardingTourProps } from "./OnboardingTour.types";

const OnboardingTour: React.FC<OnboardingTourProps> = ({
  steps,
  open,
  currentStep,
  onStepChange,
  onClose,
  onFinish,
}) => (
  <Tour
    open={open}
    onClose={onClose}
    steps={steps}
    current={currentStep}
    indicatorsRender={() => <span />}
    actionsRender={(_originNode, info) => (
      <div className="onboarding-step-actions">
        {info.current === info.total - 1 ? (
          <BubbleButton
            size="m"
            onClick={onFinish}
            text="Завершить"
          />
        ) : (
          <>
            {info.current === 0 ? (
              <BubbleButton
                size="m"
                onClick={onFinish}
                text="Пропустить"
              />
            ) : (
              <BubbleButton
                size="m"
                onClick={() => onStepChange(info.current - 1)}
                text="Назад"
              />
            )}
            <BubbleButton
              size="m"
              onClick={() => onStepChange(info.current + 1)}
              text="Далее"
            />
          </>
        )}
      </div>
    )}
  />
);

export default OnboardingTour;
